import { useEffect } from 'react';

const ORIGIN = 'https://patrolit.org';

/**
 * Points the page's canonical link at its own URL while it is shown
 * (2026-10-12; sibling finding 2026-10-10-public-site-seo-basics).
 *
 * index.html carries one static canonical, "https://patrolit.org/", for every
 * route of this single-page app - so /register, which is in the sitemap,
 * told Google it was a copy of the home page, and could be dropped from the
 * index as a duplicate. Google renders the JavaScript, so setting it here is
 * what it reads. Restored on leaving, for the home page.
 */
export function useCanonical(path: string): void {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) return;
    const before = link.href;
    link.href = ORIGIN + path;
    return () => { link.href = before; };
  }, [path]);
}
